let lastScroll = 0;
const navigation = document.querySelector("#primaryMenu");
const scrollUp   = "scrolledUp";
const scrollUpBg = "bg-none";
const scrollUpBgDark = "bg-none";
const scrollDown = "-translate-y-36";

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 60) {
    navigation.classList.remove(scrollUp, scrollUpBg, scrollUpBgDark);
    return;
  }

  if (currentScroll > lastScroll && !navigation.classList.contains(scrollDown)) {
    // down
    navigation.classList.remove(scrollUp, scrollUpBg, scrollUpBgDark);
    navigation.classList.add(scrollDown);
  } else if (
    currentScroll < lastScroll &&
    navigation.classList.contains(scrollDown)
  ) {
    // up
    navigation.classList.remove(scrollDown);
    navigation.classList.add(scrollUp, scrollUpBg, scrollUpBgDark);
  }
  lastScroll = currentScroll;
});